import Axios from "axios";
import Firebase from "firebase";

const UserListStore = {
  namespaced: true,
  debug: true,
  state: {
    userList: []
  },
  mutations: {
    async setUserList(state, data) {
      state.userList = data;
    }
  },
  getters: {
    getUserSelectValidObjects(state) {
      return state.userList;
    }
  },
  actions: {
    async callAdminUserSelectObjects({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let userList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/userList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setUserList", userList.data);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default UserListStore;
